import { Navigate, Outlet } from 'react-router-dom';

interface AuthWrapperProps {
  isAuthenticated: boolean;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ isAuthenticated }) => {
  // return isAuthenticated ? <Outlet />  : <Navigate to="//login" replace />;
  return <Outlet />;
};

export default AuthWrapper;